import { useState, useMemo } from "react";
import { getAddressList } from "../services/checkoutService";
import { getMarketCountry } from "../services/siteService";

function useAddressFunctions(fields) {
  const { newAddressLabel } = fields;
  const [addressLoaded, setAddressLoaded] = useState(false);
  const [marketCountry, setMarketCountry] = useState(null);
  const [addressList, setAddressList] = useState([]);
  const noAddress = useMemo(() => (addressLoaded ? addressList.filter(x => x.value !== "new").length === 0 : true), [addressLoaded, addressList]);
  const loadAddressList = async () => {
    const _marketCountry = await getMarketCountry();
    !marketCountry && setMarketCountry(_marketCountry);
    let _addressList = await getAddressList(newAddressLabel.value);
    _addressList = _addressList.filter(x => x.value === "new" || x?.address?.countryCode === _marketCountry?.regionAbbr);
    setAddressList(_addressList);
    setAddressLoaded(true);
    return _addressList;
  };
  const addAddress = async address => {
    const newAddressList = await loadAddressList();
    const addedItem = newAddressList.find(x => addressList.every(y => x.value !== y.value));
    addedItem.address.firstName = address.firstName;
    addedItem.address.lastName = address.lastName;
    addedItem.isNew = true;
    return addedItem;
  };
  const updateAddress = async address => {
    const newAddressList = await loadAddressList();
    const updatedAddress = newAddressList.find(x => x.value === address.value);
    setAddressList(newAddressList);
    return updatedAddress;
  };
  const removeAddress = address => {
    const index = addressList.findIndex(x => x === address);
    addressList.splice(index, 1);
    const newAddressList = addressList.slice();
    const newAddr = newAddressList.find(x => x.isNew);
    if (newAddr) {
      delete newAddr.isNew;
    }
    setAddressList(newAddressList);
  };
  return {
    addressList,
    addressLoaded,
    marketCountry,
    noAddress,
    loadAddressList,
    addAddress,
    updateAddress,
    removeAddress
  };
}
export default useAddressFunctions;
